import { render, staticRenderFns } from "./medicines.vue?vue&type=template&id=83e25d70"
import script from "./medicines.vue?vue&type=script&lang=js"
export * from "./medicines.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports